module.exports = __webpack_public_path__ + "static/media/snails.5edb4e73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/snails.svg
// module id = 1129
// module chunks = 0